import { Collapse, Stack, Typography, Stepper, Step, StepLabel } from '@mui/material';
import React from 'react';
import { format } from 'date-fns';
import { ArrowForwardIos } from '@mui/icons-material';

function BatchEntry({ batch, steps}) {
    const [isExpanded, setIsExpanded] = React.useState(false);

    const activeStepIndex = batch.status === 'completed' ? 5 : steps.findIndex(step => step.key === batch.current_step);

    return (
        <Stack key={batch.id} backgroundColor='white' my={2} p={2} boxShadow={2} borderRadius='8px' onClick={() => setIsExpanded(!isExpanded)} sx={{ cursor: 'pointer' }}>
            <Stack direction='row' justifyContent='space-between' alignItems='center'>
                <Stack spacing={1}>
                    <Typography variant='normal' fontSize='16px'>{batch.hospital.name}</Typography>
                    <Stack direction='row' spacing={2} alignItems='center'>
                        <Typography><b>Batch ID:</b> {batch.id}</Typography>
                        <Typography><b>Status:</b> {batch.status.split('_').map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(' ')}</Typography>
                        <Typography><b>Created At:</b> {format(new Date(batch.created_at), 'MMMM dd, yyyy h:mm a')}</Typography>
                    </Stack>
                </Stack>
                <ArrowForwardIos sx={{ transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }} size='small' />
            </Stack>
            <Collapse in={isExpanded}>
                <Stepper activeStep={activeStepIndex} alternativeLabel sx={{ marginTop: 3 }}>
                    { steps.map((step) => (
                        <Step key={step.key}>
                            <StepLabel>{step.label}</StepLabel>
                        </Step>
                    )) }
                </Stepper>
            </Collapse>
        </Stack>
    )
}

export default BatchEntry;
